// Shared handling for the asset and minor-item attachment dropzones.
//
// NB: overriding Dropzone's `error` callback suppresses its default red-X
// marking, so a failed upload MUST be surfaced here or it is invisible to the
// user. A silent console.error here hid months of lost minor-item uploads.
function uploadFailed(file, response) {
  var message = (response && response.error) || 'The file could not be uploaded. Please try again.';

  console.error('File upload failed:', response);

  var errors = document.querySelector('[data-show-files-errors]');
  if (errors) {
    errors.textContent = file.name + ': ' + message;
    errors.style.display = 'block';
  } else {
    alert(file.name + ': ' + message);
  }

  if (file.previewElement) {
    file.previewElement.classList.add('dz-error');
  }
}

function uploadSucceeded(file, response) {
  if (response && response.success) {
    document.querySelector('[data-attachments]').innerHTML = response.html;
    return;
  }

  // A 2xx that isn't success is still a failure - don't let it look like one.
  uploadFailed(file, response);
}

window.Dropzone.options.assetAttachmentDropzone = {
  success: uploadSucceeded,
  error: uploadFailed
};

window.Dropzone.options.itemAttachmentDropzone = {
  success: uploadSucceeded,
  error: uploadFailed
};
